// extracted by mini-css-extract-plugin
export default {"modal":"BankAcocuntSelectModal_modal__HfELl"};